import { ThemRadius } from '../ThemeInterface'

const radius: ThemRadius = {
  s: '8px',
  m: '18px',
  l: '20px',
}

export default radius
